import axios from "axios";
import { toast } from "react-toastify";

function applyGlobalHeaders() {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const guestId = localStorage.getItem("guest_id");
  const isGuest = localStorage.getItem("is_guest");

  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axios.defaults.headers.common["x-access-token"] = token;
  } else if (isGuest && guestId) {
    axios.defaults.headers.common["x-guest-id"] = guestId;
  }
}

applyGlobalHeaders();

function getAuthHeaders() {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const isGuest = localStorage.getItem("is_guest");
  const guestId = localStorage.getItem("guest_id");

  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
    headers["x-access-token"] = token;
  } else if (isGuest && guestId) {
    headers["x-guest-id"] = guestId;
  }

  return headers;
}

// axios.interceptors.response.use(null, (error) => {
//   console.log("🚨 AXIOS 401:", {
//     status: error.response?.status,
//     isGuest: localStorage.getItem("is_guest"),
//   });

//   console.log(error);
//   const expectedError =
//     error.response &&
//     error.response.status >= 400 &&
//     error.response.status < 500;

//   if (error.response?.data?.guestLimit) {
//     toast.info("Guest limit reached. Please login to continue.");
//     localStorage.removeItem("is_guest");
//     localStorage.removeItem("guest_id");
//     window.location.href = "/login";
//     return;
//   }

//   if (!expectedError) {
//     console.log(error);
//     toast.error("An unexpected error occurrred.");
//   }

//   return Promise.reject(error);
// });

axios.interceptors.response.use(
  (response) => {
    console.log("✅ AXIOS SUCCESS:", {
      url: response.config?.url,
      status: response.status,
      isGuest: localStorage.getItem("is_guest"),
      token: sessionStorage.getItem("token"),
    });
    return response;
  },
  (error) => {
    console.log("🚨 AXIOS ERROR:", {
      url: error.config?.url,
      status: error.response?.status,
      isGuest: localStorage.getItem("is_guest"),
      token: sessionStorage.getItem("token"),
    });

    const expectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (error.response?.data?.guestLimit) {
      console.log("⚠ Guest limit reached");
      toast.info("Guest limit reached. Please login to continue.");
      localStorage.removeItem("is_guest");
      localStorage.removeItem("guest_id");
      window.location.replace("/login");
      return;
    }

    if (!expectedError) {
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  },
);

function setJwt(jwt) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
  axios.defaults.headers.common["x-access-token"] = jwt;
}

async function getFetch(apiEndpoint) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "GET",
    headers: getAuthHeaders(),
    // headers: {
    //   "Content-Type": "application/json",
    //   "x-access-token": sessionStorage.getItem("token")
    //     ? sessionStorage.getItem("token")
    //     : localStorage.getItem("token"),
    // },
  });
  const isGuest = localStorage.getItem("is_guest") === "true";

  response = await response.json();
  console.log("📡 GET API RESPONSE:", {
    endpoint: apiEndpoint,
    status: response.status,
    isGuest: localStorage.getItem("is_guest"),
    token: localStorage.getItem("token"),
  });
  if (response.status === 401) {
    if (!isGuest) {
      toast.error(response.message);
      // localStorage.clear();
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.setItem("sessiontimeout", true);
      localStorage.removeItem("token");
      window.location.href = "/login";
    } else {
      return response;
    }
  } else {
    return response;
  }
}

async function deleteFetch(apiEndpoint) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
    // headers: {
    //   "Content-Type": "application/json",
    //   "x-access-token": sessionStorage.getItem("token")
    //     ? sessionStorage.getItem("token")
    //     : localStorage.getItem("token"),
    // },
  });
  response = await response.json();
  const isGuest = localStorage.getItem("is_guest") === "true";

  if (response.status === 401) {
    if (!isGuest) {
      toast.error(response.message);
      // localStorage.clear();
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.setItem("sessiontimeout", true);
      sessionStorage.removeItem("token");
      window.location.href = "/login";
    } else {
      return response;
    }
  } else {
    return response;
  }
}

async function postFetch(apiEndpoint, data) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "POST",
    headers: getAuthHeaders(),
    // headers: {
    //   "Content-Type": "application/json",
    //   "x-access-token": sessionStorage.getItem("token")
    //     ? sessionStorage.getItem("token")
    //     : localStorage.getItem("token"),
    // },
    body: JSON.stringify(data),
  });

  response = await response.json();
  const isGuest = localStorage.getItem("is_guest") === "true";

  console.log("📡 POST API RESPONSE:", {
    endpoint: apiEndpoint,
    status: response.status,
    isGuest: localStorage.getItem("is_guest"),
    token: localStorage.getItem("token"),
  });

  if (response.status === 401) {
    if (!isGuest) {
      toast.error(response.message);
      // localStorage.clear();
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.setItem("sessiontimeout", true);
      sessionStorage.removeItem("token");
      window.location.href = "/login";
    } else {
      return response;
    }
  } else {
    return response;
  }
}

async function putFetch(apiEndpoint, data) {
  let response = await fetch(`${apiEndpoint}`, {
    method: "PUT",
    headers: getAuthHeaders(),
    // headers: {
    //   "Content-type": "application/json;", // Indicates the content
    //   "Access-Control-Allow-Origin": "*",
    // },
    body: JSON.stringify(data), // We send data in JSON format
  });
  response = await response.json();
  const isGuest = localStorage.getItem("is_guest") === "true";
  if (response.status === 401) {
    if (!isGuest) {
      toast.error(response.message);
      // localStorage.clear();
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.setItem("sessiontimeout", true);
      sessionStorage.removeItem("token");
      window.location.href = "/login";
    } else {
      return response;
    }
  } else {
    return response;
  }
}

export default {
  get: getFetch,
  post: postFetch,
  put: putFetch,
  delete: deleteFetch,
  setJwt,
};
